import React from "react";
import parse from "html-react-parser";
import { useContent } from "contexts/contentContext/contentContext";

interface existsAddonsI {
  existsAddons: {
    has_active: boolean;
    has_cancelled: boolean;
    has_expired: boolean;
    sub_users?: boolean;
    extra_storage?: boolean;
  };
}

const ExistAddonsElement = ({ existsAddons }: existsAddonsI) => {
  const { getTextByKey, getHtmlByKey } = useContent();

  const hasActiveText = getTextByKey(
    "cancel-your-subscription-step1-addons-text"
  )
    .replace(
      "#exists-sub-users#",
      existsAddons.sub_users ? getTextByKey("exists-sub-users-text") : ""
    )
    .replace(
      "#exists-extra-storage#",
      existsAddons.extra_storage
        ? getTextByKey("exists-extra-storage-text")
        : ""
    );

  return (
    <div className="cancel-subscription-element-side-section top">
      {parse(hasActiveText)}
      {existsAddons.sub_users ? (
        <p className="addon-link">{getHtmlByKey("exists-sub-users")}</p>
      ) : null}
      {existsAddons.extra_storage ? (
        <p className="addon-link">{getHtmlByKey("exists-extra-storage")}</p>
      ) : null}
    </div>
  );
};

export default ExistAddonsElement;
